import { wmfetch } from "@/helpers/wmfetch";

export function getWrongWordStatisticsDetail(data) {
  return wmfetch({
    url: "/api/alert/wx/warnning/wrong-word/detail",
    method: "get",
    params: data,
  });
}

export function getWechatCode(data) {
  return wmfetch({
    url: "/api/wechat",
    method: "get",
    params: data,
  });
}
